// React
import { useHistory, useParams } from 'react-router-dom';
import React, { useEffect, useState } from 'react';

// Yup Validation
import * as Yup from 'yup';
import { useFormik } from 'formik';

// Containers Injections
import { SuppliersInjection } from '../../containers/suppliersInjection';

// View
import { SuppliersFormPage } from './view';

// Utils
import { useLoading } from '../../../../hook/useLoading';
import '../../../../utils/validation/cpfMethodValidation';
import { APIClient } from '../../../../helpers/api_helper';

export const SuppliersForm = () => {
  const [supplier, setSupplier] = useState({});
  const [isActive, setIsActive] = useState(true);
  const [typeMask, setTypeMask] = useState('CPF');

  const { createSuppliers, updateSuppliers } = SuppliersInjection();

  const { id } = useParams();
  const api = new APIClient();
  const history = useHistory();
  const { loadingWithTime } = useLoading();

  const getSuppliersById = async (id) => {
    const supplier = await api.get(`/register/person/${id}`);

    if (supplier) {
      setSupplier(supplier);
      setIsActive(supplier.active === true ? true : false);
      setTypeMask(
        supplier?.cnpj_cpf && supplier?.cnpj_cpf.length === 11 ? 'CPF' : 'CNPJ'
      );
    }
  };

  const resetCpfCnpjInput = () => {
    if (validation.values.cpfInput) {
      validation.handleChange({
        target: {
          name: 'cpfInput',
          value: '',
        },
      });
    }
  };

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      // principal
      nameInput: supplier ? supplier.name : '',
      cpfInput: supplier ? supplier.cnpj_cpf : '',
      obsInput: supplier ? supplier.notes : '',
      logo: supplier ? supplier.logo : '',
      // contact
      contactInput: supplier ? supplier.contact : '',
      phone1Input: supplier ? supplier.phones?.phone1 : '',
      phone2Input: supplier ? supplier.phones?.phone2 : '',
      emailInput: supplier ? supplier.email : '',
      phone3: supplier ? supplier.phones?.phone3 : '',
      siteInput: supplier ? supplier?.social_media?.site : '',
      instagramInput: supplier ? supplier?.social_media?.ig : '',
      // address
      zipInput: supplier ? supplier.zipcode : '',
      streetInput: supplier ? supplier.address1 : '',
      numberInput: supplier ? supplier.address_num : '',
      address2Input: supplier ? supplier.address2 : '',
      neighborhoodInput: supplier ? supplier.district : '',
      cityInput: supplier
        ? { value: supplier.city_id, label: supplier.city_name }
        : '',
      isActiveSelect: supplier && (supplier.active === true ? true : false),
    },

    validationSchema: Yup.object({
      // principal
      nameInput: Yup.string().nullable().required('Nome é obrigatório'),
      cpfInput:
        typeMask === 'CPF' ? Yup.string().nullable() : Yup.string().nullable(),
      obsInput: Yup.string().nullable(),
      logo: Yup.string().nullable(),
      // contact
      contactInput: Yup.string().nullable(),
      phone1Input: Yup.string().nullable(),
      phone2Input: Yup.string().nullable(),
      emailInput: Yup.string().nullable(),
      phone3: Yup.string().nullable(),
      // address
      zipInput: Yup.string().nullable(),
      streetInput: Yup.string().nullable(),
      numberInput: Yup.string().nullable(),
      address2Input: Yup.string().nullable(),
      neighborhoodInput: Yup.string().nullable(),
      cityInput: Yup.object().nullable(),
      isActiveSelect: Yup.string().nullable(),
    }),

    onSubmit: (values) => {
      const valuesToSubmit = {
        name: values.nameInput || null,
        cnpj_cpf: values.cpfInput || null,
        address1: values.streetInput || null,
        address_num: values.numberInput || null,
        address2: values.address2Input || null,
        district: values.neighborhoodInput || null,
        zipcode: values.zipInput || null,
        city_id: values.cityInput.value || null,
        contact: values.contactInput || null,
        email: values.emailInput || null,
        notes: values.obsInput || null,
        phone1: values.phone1Input || null,
        phone2: values.phone2Input || null,
        phone3: values.phone3 || null,
        logo: values.logo || null,
        active: isActive,
        record_type: 'F',
        type_person: typeMask === 'cpf' ? 'F' : 'J',
      };
      loadingWithTime(1000);
      if (supplier.id) {
        updateSuppliers(supplier.id, {
          ...valuesToSubmit,
        });
        history.goBack();
      } else {
        createSuppliers(valuesToSubmit);
        history.goBack();
      }
    },
  });

  useEffect(() => {
    if (id) {
      getSuppliersById(id);
    }
  }, [id]);

  return (
    <SuppliersFormPage
      id={id}
      history={history}
      typeMask={typeMask}
      isActive={isActive}
      validation={validation}
      supplier={supplier || []}
      setTypeMask={setTypeMask}
      setIsActive={setIsActive}
      resetCpfCnpjInput={resetCpfCnpjInput}
    />
  );
};
